import { IPagination } from '../types/pagination';
import { statusColor } from '../utils/statusColor';
import { _initialCustomer } from '../views/project/reducers/projectReducer';
import { IProjectBudgetCost } from '../views/project/types/costs';
import {
  ICustomer,
  IDepartmentTrend,
  IDepartmentTrendHours,
  IProject,
  IProjectDepartmentsChartData,
  IProjectFinancialCalculation,
  IProjectHealthChartData,
  IProjectLabel,
  IProjectPhase,
  IProjectsHealthWidget,
  IProjectsResponse,
  ITimeTrackingPermission
} from '../views/project/types/project';
import {
  ICostByMonths,
  ICostData, ICostsByPhaseChart, IDepartmentExpendituresByMonths,
  IDepartmentExpendituresTimeline,
  IExpendituresByLabels
} from '../views/project/types/projectActivity';
import { IExpendituresByTasks, IProjectCostBurndownWidget } from './../views/project/types/projectActivity';
import { _activities } from './activityFixtures';
import { _employees } from './employeeFixtures';

export const _initialProject: IProject = {
  id: '',
  name: '',
  customer: _initialCustomer,
  category: '',
  type: '',
  permissions: '',
  employees: [],
  start_date: null,
  end_date: null,
  budget: 0,
  phases: [],
  time_used: 0,
  budget_used: 0,
  invoiced: 0,
  health: '',
  healthColor: (health: string) => statusColor(health),
  activities: [],
  direct_costs: [],
  active: true,
  color: '',
  labels: [],
  time_tracking_perm: {} as ITimeTrackingPermission,
  individual_employee_rate: [],
  project_billing_rate: 'individual',
  billing_procedure: 'billing_on_actual',
  cost_rate_billing: [],
  project_billing_rate_id: '',
  financial_calculation: {} as IProjectFinancialCalculation,
  accounting: false,
  admins: [],
  offers: [],
  deleted_on: null,
  inactive_on: null,
  expenditures_budget_widget: 0,
  notifications: []
}

export const _initialProjectsHealthWidget: IProjectsHealthWidget = {
  on_track: 0,
  at_risk: 0,
  off_track: 0
}

export const _initialProjectFinancialCalculation: IProjectFinancialCalculation = {
  accounting_expenditures: 0,
  accounting_forecast: 0,
  activities_expenditures: 0,
  total_budget: 0
}

export const _initialBudgetChart: IProjectDepartmentsChartData = {
  categories: [],
  data: []
}

export const _projects: IProject[] = [
  {
    id: 1,
    name: 'Test Project One',
    type: 'sponsor',
    permissions: 'restricted',
    employees: _employees,
    start_date: null,
    end_date: null,
    budget: 1000,
    phases: [
      { id: 1, name: 'Test Phase One', active: true, start_date: '', end_date: '', finished: false, color: '#2F61D5' }
    ],
    time_used: 0,
    budget_used: 0,
    invoiced: 0,
    health: 'on_track',
    healthColor: (health: string) => statusColor(health),
    activities: _activities,
    direct_costs: [],
    active: true,
    color: '#FCDC00',
    labels: [],
    time_tracking_perm: { } as ITimeTrackingPermission,
    individual_employee_rate: [],
    project_billing_rate: 'individual',
    billing_procedure: 'billing_on_actual',
    cost_rate_billing: [],
    project_billing_rate_id: '',
    accounting: false,
    financial_calculation: {} as IProjectFinancialCalculation,
    admins: [],
    offers: [],
    deleted_on: null,
    inactive_on: null,
    expenditures_budget_widget: 0,
    notifications: []
  },
  {
    id: 2,
    name: 'Test Project Two',
    type: 'sponsor',
    permissions: 'restricted',
    employees: _employees,
    start_date: '',
    end_date: '',
    budget: 1000,
    phases: [
      { id: 1, name: 'Test Phase One', active: true, start_date: '', end_date: '', finished: false, color: '#2F61D5' }
    ],
    time_used: 0,
    budget_used: 0,
    invoiced: 0,
    health: 'on_track',
    healthColor: (health: string) => statusColor(health),
    activities: _activities,
    direct_costs: [],
    active: true,
    color: '#FCDC00',
    labels: [{id: 1, name: 'testLabelOne', color: '#2F61D5'}],
    time_tracking_perm: { } as ITimeTrackingPermission,
    individual_employee_rate: [],
    project_billing_rate: 'individual',
    billing_procedure: 'billing_on_actual',
    cost_rate_billing: [],
    project_billing_rate_id: '',
    accounting: false,
    financial_calculation: {} as IProjectFinancialCalculation,
    admins: [],
    offers: [],
    deleted_on: null,
    inactive_on: null,
    expenditures_budget_widget: 0,
    notifications: []
  }
]

export const _projectsResponse: IProjectsResponse  = {
  filtered: _projects,
  all_count: 0
}

export const _customer: ICustomer = {
  id: 1,
  name: 'Test',
  address: 'Test address',
  city: 'Test city',
  phone_number: '0600000',
  email: 'test@email.com'
}

export const _projectPhase: IProjectPhase = {
  id: 1,
  name: 'Test',
  active: true,
  start_date: '',
  end_date: '',
  finished: false,
  color: '#FCDC00'
}

export const _initialProjectPhase: IProjectPhase[] = [
  { id: '', name: '', active: true, start_date: '', end_date: '', finished: false, color: '#FCDC00' }
]

export const _initialBudgetCosts: IProjectBudgetCost[] = [
  {
    id: '',
    position: '',
    supplier: '',
    quantity: 0,
    unit_price: 0,
    total_cost: 0,
    phases: [] as IProjectPhase[],
    labels: [] as IProjectLabel[],
    project_cost_category_id: '',
    thereof_paid: '',
    position_status: 'open',
    payments: []
  }
]

const _initialDepartmentByMonthsFixture: IDepartmentExpendituresByMonths = {
  month: 1,
  cost: 0
}

export const _initialDepartmentTimelineFixture: IDepartmentExpendituresTimeline = {
  name: '',
  data: [_initialDepartmentByMonthsFixture]
}

export const _initialDepartmentTimelinePaginationFixture: IPagination<IDepartmentExpendituresTimeline[]> = {
  links: { next: '', previous: '' },
  count: 0,
  current_page: 0,
  total_pages: 0,
  results: [],
  page_size: 5,
  last_page: 0,
  to: 0,
  from: 0
}

export const _initialExpendituresBurndownFixture: IProjectCostBurndownWidget = {
  data: [],
  categories: [],
  colors: []
}

export const _initialExpendituresByLabelsCostsFixture: IExpendituresByTasks = {
  cost_name: '',
  cost: 0,
  labels: ['']
}

export const _initialExpendituresByTasksPaginationFixture: IPagination<IExpendituresByTasks[]> = {
  links: { next: '', previous: '' },
  count: 0,
  current_page: 0,
  total_pages: 0,
  results: [],
  page_size: 5,
  last_page: 0,
  to: 0,
  from: 0
}

export const _initialExpendituresByLabelsFixture: IExpendituresByLabels = {
  name: '',
  color: '',
  total: 0
}

export const _initialCostByMonthsDataFixture: ICostData = {
  name: '',
  cost: 0
}

export const _initialCostByMonthsFixture: ICostByMonths = {
  year: 0,
  month: 0,
  data: [_initialCostByMonthsDataFixture]
}

export const _initialDepTrendHoursFixture: IDepartmentTrendHours = {
  name: '',
  data: []
}

export const _initalDepTrendFixture: IDepartmentTrend = {
  categories: [],
  trend_hours: [_initialDepTrendHoursFixture]
}

export const _initialCostsByPhaseDataFixture: ICostsByPhaseChart = {
  data: [{ name: '', data: [] }],
  categories: []
}

export const _initialProjectChartData: IProjectHealthChartData = {
  series: [0, 0, 0],
  labels: ['On Track 0%', 'At Risk 0%', 'Off Track 0%'],
  colors: ['#65D393', '#FECD93', '#F68282']
}

